import script from "./FileDropzone.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileDropzone.vue?vue&type=script&setup=true&lang=ts"

import "./FileDropzone.vue?vue&type=style&index=0&id=6e3ab414&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e3ab414"]])

export default __exports__